// import external libraries
import { useQuery } from 'react-query';

// import data
import { getRosterFunctionsByCostCenterAndDate } from 'RestAPIs/roster/functions';

// import types
import type { RosterFunction } from 'components/types';

/**
 * The roster functions of the given cost centres.
 *
 * Wraps the existing call rather than adding one. Two things are corrected here rather than in the shared
 * API, which other pages depend on: the call declares its own request type as the response type, while the
 * endpoint answers with roster functions (id and description, as the flex match filter reads them); and it
 * takes no query options, so without this the list would be fetched before a plan unit is even picked.
 */
export const useBacklogFunctionOptions = (
  costCenters: string,
  startDate: string,
  endDate: string
) =>
  useQuery(
    ['backlogRosterFunctions', costCenters, startDate, endDate],
    async () => {
      const { data } = await getRosterFunctionsByCostCenterAndDate({
        // The query parameter is `costCenters`, so the comma-separated list of picked plan units goes in
        // where the type names a single id.
        costCenterId: costCenters as unknown as number,
        startDate,
        endDate
      });
      return data as unknown as RosterFunction[];
    },
    { enabled: !!costCenters }
  );
